import { useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import navigationService from "../../navigation/NavigationService"
import { useAppDependencies } from "../../context/AppContext"
import StateConstants from "../../states/StateContstants"

interface NavigationProviderProps {
    children: React.ReactNode
}

/**
 * Provider component that sets up the navigation service with React Router's navigate function.
 * Clears error state in the state handler on navigation so previous page errors are not shown.
 */
export default function NavigationProvider({ children }: NavigationProviderProps) {
    const navigate = useNavigate()
    const location = useLocation()
    const { stateHandler } = useAppDependencies()

    useEffect(() => {
        navigationService.setNavigate(navigate)
    }, [navigate])

    useEffect(() => {
        stateHandler.set(StateConstants.ERROR, null)
    }, [location.pathname, stateHandler])

    return <>{children}</>
}

